import { useQuery } from '@tanstack/react-query'

import { fetchWithHeaders } from 'utils'

import { GrapeAPIError, type GrapeAPIErrorType } from './GrapeAPIError'
import { type PaginatedResponse } from './types'
import { type Employee } from '../../types'

type useGetPayScheduleEmployeesParams = {
  payScheduleId: string,
  pagination: {
    pageIndex: number,
    pageSize: number
  },
  search?: string
}

export function getPayScheduleEmployeesQueryKey ({ payScheduleId, pagination, search }: useGetPayScheduleEmployeesParams) {
  return ['employers', 'employees', payScheduleId, 'pagination', pagination, 'search', search]
}

export function useGetPayScheduleEmployees ({
  payScheduleId,
  pagination,
  search
}: useGetPayScheduleEmployeesParams
) {
  return useQuery<PaginatedResponse<Employee>, GrapeAPIErrorType>({
    queryKey: getPayScheduleEmployeesQueryKey({ payScheduleId, pagination, search }),
    queryFn: async () => {
      const queryParams: Record<string, any> = {
        'page[number]': pagination.pageIndex.toString(),
        'page[size]': pagination.pageSize.toString(),
        search,
      }
      const queryString = new URLSearchParams(queryParams).toString()
      const response = await fetchWithHeaders(`/api/web/employers/employees/pay_schedules/${payScheduleId}?${queryString}`)

      if (!response.ok) {
        const errorJson = await response.json()
        throw GrapeAPIError({
          status: response.status,
          message: errorJson.message,
          errors: errorJson.errors
        })
      }

      return response.json()
    },
  })
}
